import React, { Component, Fragment } from "react";
import { toast } from "react-toastify";
import ItemsTable, {
  filterFieldData,
} from "../../../components/tableComponents/itemsTable";
import rolesService from "../../../services/auth/rolesService";
import {
  mapEntityList,
  createFilterData,
} from "../../../services/utility/autoMapperService";
import userRoleFunctionService from "../../../services/auth/userRoleFunctionService";
import _ from "lodash";
import TableFilterPane from "../../../components/tableComponents/tableFilterPane";
import { IFilterData } from "../../../services/approval/approvalItemService";
import { printPDF } from "../../../services/utility/textFormatService";
import BaseListComponent, {
  BaseListComponentState,
} from "../../../components/BaseListComponent";
import AuditTrailDetail from "../../auditTrail/auditTrailDetail";
import UserRoleDetail from "./userRoleDetail";
import EditUserRole from "./editUserRole";

export interface IUserRolesProps {}

interface IUserRolesState extends BaseListComponentState {
  data: IFilterData;
  currentPage: number;
  pageSize: number;
  tableItems: any;
  totalSize: number;
  fetchingDetail: boolean;
  filterValueInput: filterFieldData;
  item: any;
  functions: any;
}

class UserRolesList extends BaseListComponent<IUserRolesState> {}

class UserRoles extends Component<IUserRolesProps, IUserRolesState> {
  constructor(props: IUserRolesProps) {
    super(props);
    this.state = {
      data: createFilterData(["name", "status", "code", "roleVisibility"]) as IFilterData,
      currentPage: 1,
      pageSize: Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
      fetching: false,
      fetchingDetail: false,
      tableItems: [],
      totalSize: 0,
      filterValueInput: [
        { name: "name", fieldType: "text", value: "" },
        { name: "code", fieldType: "text", value: "" },
        {
          name: "roleVisibility",
          fieldType: "select",
          options: ["Branch", "Regional", "Global"],
          value: "",
        },
        {
          name: "status",
          fieldType: "select",
          options: ["Active", "Inactive"],
          value: "",
        },
      ],
      item: {},
      showDetailsModal: false,
      showEditModal: false,
      showTableFilterModal: false,
      showTrailModal: false,
      functions: {},
    };
  }

  handlePageChange = async (currentPage: number, pageSize:number, data?: IFilterData) => {
    currentPage = currentPage < 0 ? this.state.currentPage : currentPage;
    pageSize = pageSize < 0 ? this.state.pageSize : pageSize;
    this.setState({ fetching: true });
    data = typeof data === "undefined" ? this.state.data : data;
    try {
      const userRoles = await rolesService.filterRoles(
        data,
        pageSize,
        currentPage
      );
      const functions = await userRoleFunctionService.retrieveAllFunctionsByInstitution();
      this.setState({
        functions: functions.data,
        tableItems: mapEntityList({
          entityList: userRoles.data.item2,
          properties: [
            { oldName: "name", newName: "name" },
            { oldName: "code", newName: "code" },
            { oldName: "description", newName: "description" },
            { oldName: "roleVisibility", newName: "roleVisibility" },
            {
              isTag: true,
              oldName: "status",
              newName: "status",
              success: "Active",
              danger: "Inactive",
              default: "default",
              primary: "primary",
              secondary: "secondary",
              warning: "warning",
              light: "light",
              dark: "dark",
            },
          ],
        }),
        currentPage,
        pageSize,
        totalSize: userRoles.data.item1,
        fetching: false,
      });
    } catch (ex) {
      // console.log("caught exception", ex);
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 499
      ) {
        // toast.error("Bad Request");
        // console.log(ex.response);
        // errors["response"] = "Internal server error.";
        // console.log(errors);
        // this.setState({ errors, fetching: false });
      } else {
        // toast.error("Internal server error. Please contact the admin.");
        // console.log(ex);
        // this.setState({ errors, fetching: false });
      }
    } finally {
      this.setState({ fetching: false });
    }
  };

  handleOnExport = async (type: string) => {
    try {
      switch (type) {
        case "XLSX":
        case "CSV":
          return await rolesService.downloadReport(type);
        case "PDF":
          const response = await rolesService.downloadReportPDF();
          printPDF(response.data);
          break;
        default:
      }
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 499
      ) {
        // toast.error("Bad Request");
        // console.log(ex.response);
        // errors["response"] = "Internal server error.";
        // console.log(errors);
      } else {
        // toast.error("Internal server error. Please contact the admin.");
        //this.setState({ errors, fetching: false });
      }
    }
  };

  fetchItemById = async (item: any) => {
    this.setState({ fetchingDetail: true });
    const userRole = await rolesService.retrieveRoleById(item.id);
    // console.log("userRole: ", userRole.data);
    this.setState({ item: userRole.data, fetchingDetail: false });
  };

  getFilteredItems = (data: IFilterData): IFilterData => {
    let filteredItems: IFilterData = {};
    Object.keys(data).forEach((key) => {
      if (data[key].item2 !== "") {
        filteredItems[key] = data[key];
      }
    });
    return filteredItems;
  };

  async componentDidMount() {
    this.handlePageChange(this.state.currentPage, this.state.pageSize);
  }
  render() {
    const {
      currentPage,
      pageSize,
      tableItems,
      totalSize,
      fetching,
      item,
      fetchingDetail,
    } = this.state;
    return (
      <React.Fragment>
        <div className="container-fluid relative animatedParent animateOnce">
          <div className="animated fadeInUpShort go">
            <div className="row my-3 mx-2">
              <h3>
                <b>User Roles</b>
              </h3>
            </div>

            <UserRolesList
              pageChangeHandler={this.handlePageChange}
              fetchingDetail={fetchingDetail}
              initialValues={{
                data: createFilterData([
                  "name",
                  "status",
                  "code",
                  "roleVisibility",
                ]) as IFilterData,
                fetching: false,
                showDetailsModal: false,
                showEditModal: false,
                showTableFilterModal: false,
                showTrailModal: false,
                tableItems: [],
                filterValueInput: [
                  { name: "name", fieldType: "text", value: "" },
                  { name: "code", fieldType: "text", value: "" },
                  {
                    name: "roleVisibility",
                    fieldType: "select",
                    options: ["Branch", "Regional", "Global"],
                    value: "",
                  },
                  {
                    name: "status",
                    fieldType: "select",
                    options: ["Active", "Inactive"],
                    value: "",
                  },
                ],
                item: {},
                jsonBefore: {},
                jsonAfter: {},
                fetchingTrail: false,
                entityName: "Recova.Auth.Role",
              }}
              tableItems={tableItems}
              item={item}
              DetailsModal={({
                item,
                onToggleDetailsModal,
                onToggleEditModal,
                showDetailsModal,
                showEditModal,
                fetchTrailItem,
                fetchingTrail,
                jsonAfter,
                jsonBefore,
                onToggleTrailModal,
                showTrailModal,
                trailItem,
                trailMapper,
              }) => (
                <Fragment>
                  <UserRoleDetail
                    item={this.state.item}
                    toggleDetailsModal={onToggleDetailsModal}
                    toggleEditModal={onToggleEditModal}
                    showDetailsModal={showDetailsModal}
                    showTrail={() => onToggleTrailModal(item)}
                  />
                  <EditUserRole
                    showEditModal={showEditModal}
                    toggleEditModal={(reloadDetails: boolean, item: any) => {
                      onToggleEditModal();
                      if (reloadDetails === true) {
                        this.fetchItemById(item);
                      }
                    }}
                    item={item}
                    functions={this.state.functions}
                  />
                  <AuditTrailDetail
                    showDetailsModal={showTrailModal}
                    toggleDetailsModal={onToggleTrailModal}
                    fetchNextTrail={fetchTrailItem}
                    item={trailItem}
                    trailMapper={trailMapper}
                    fetchingDetail={fetchingTrail}
                    jsonBefore={jsonBefore}
                    jsonAfter={jsonAfter}
                  />
                </Fragment>
              )}
              ListPayLoad={({
                data,
                showTableFilterModal,
                tableItems,
                onToggleDetailsModal,
                onToggleTableFilterModal,
                onHandleFilterItemRemove,
                filterValueInput,
              }) => (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card no-b">
                      <div className="card-body">
                        <div className="card-title">
                          <div id="list-filters" className="ml-4 mr-4">
                            <TableFilterPane
                              filteredItems={this.getFilteredItems(data)}
                              handleFilterRemove={onHandleFilterItemRemove}
                            />
                          </div>
                          <div id="list-table">
                            <ItemsTable
                              data={data}
                              items={tableItems}
                              filterValueInput={filterValueInput}
                              showTableFiltermodal={showTableFilterModal}
                              toggleTableFiltermodal={onToggleTableFilterModal}
                              name="User Roles"
                              currentPage={currentPage}
                              pageSize={pageSize}
                              totalSize={totalSize}
                              fetching={fetching}
                              handlePageChange={this.handlePageChange}
                              onViewDetails={(item: any) => {
                                this.fetchItemById(item);
                                onToggleDetailsModal();
                              }}
                              handleOnExport={this.handleOnExport}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            ></UserRolesList>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default UserRoles;
